import { Col, Row } from "react-bootstrap";
import ExtensionIcon from "@mui/icons-material/Extension";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  ItemCarritoGuarderia,
} from "../../../services/carritoServicios";
import { stringADate } from "../../../utils/dateUtils";
import { StyledCalendar } from "./organisms/StyledCalendar";
import { SeccionTransporte } from "./SeccionTransporte";
import CurrencyFormat from "react-currency-format";
import { parseCurrency } from "../../../utils/numberUtils";
import { GuarderiaHandlers } from "./Model";
import { IconContainer } from "./organisms/IconContainer";
import DangerIconContainer from "../../organisms/DangerIconContainer";

export const ItemGuarderia = ({
  item,
  handlers,
  onEliminarItemClick,
}: {
  item: ItemCarritoGuarderia;
  handlers: GuarderiaHandlers;
  onEliminarItemClick: () => void;
}) => {
  const fechasProgramdasDate = item.fechasProgramadas.map((f) =>
    stringADate(f)
  );

  const onPrecioFinalPlanInputChange = (
    val: React.ChangeEvent<HTMLInputElement>
  ) => {
    const parsedPrecio = parseCurrency(val.target.value, "$", ",");
    handlers.onPrecioFinalPlanChange({
      val: parsedPrecio,
      idMascota: item.mascota.id,
      idItem: item.id,
    });
  };

  const onPrecioFinalDiaIndividualInputChange = (
    val: React.ChangeEvent<HTMLInputElement>
  ) => {
    const parsedPrecio = parseCurrency(val.target.value, "$", ",");
    handlers.onPrecioFinalDiaIndividualChange({
      val: parsedPrecio,
      idMascota: item.mascota.id,
      idItem: item.id,
    });
  };

  const onPrecioFinalTransporteIdaInputChange = (
    val: React.ChangeEvent<HTMLInputElement>
  ) => {
    const parsedPrecio = parseCurrency(val.target.value, "$", ",");
    handlers.onPrecioFinalTransporteIdaChange({
      val: parsedPrecio,
      idMascota: item.mascota.id,
      idItem: item.id,
    });
  };

  const onPrecioFinalTransporteVueltaInputChange = (
    val: React.ChangeEvent<HTMLInputElement>
  ) => {
    const parsedPrecio = parseCurrency(val.target.value, "$", ",");
    handlers.onPrecioFinalTransporteVueltaChange({
      val: parsedPrecio,
      idMascota: item.mascota.id,
      idItem: item.id,
    });
  };

  const onPrecioFinalTransporteIdaVueltaInputChange = (
    val: React.ChangeEvent<HTMLInputElement>
  ) => {
    const parsedPrecio = parseCurrency(val.target.value, "$", ",");
    handlers.onPrecioFinalTransporteIdaVueltaChange({
      val: parsedPrecio,
      idMascota: item.mascota.id,
      idItem: item.id,
    });
  };

  return (
    <>
      <h4 className="mb-3">
        <div className="d-flex justify-content-between">
          <div>
            <IconContainer>
              <ExtensionIcon />
            </IconContainer>
            Reserva de Guardería
          </div>
          <div>
            <DangerIconContainer
              style={{ cursor: "pointer" }}
              onClick={onEliminarItemClick}
            >
              <DeleteIcon />
            </DangerIconContainer>
          </div>
        </div>
      </h4>
      <section className="mb-5">
        <div>
          <label className="mb-2" style={{ fontWeight: 500 }}>
            Fechas programadas:
          </label>
          <StyledCalendar
            preSelectedDates={fechasProgramdasDate}
            disableAll={true}
          />
        </div>
      </section>

      {item.datosTransporte && (
        <SeccionTransporte
          datos={item.datosTransporte}
          fechasReserva={item.fechasProgramadas}
        />
      )}

      <section className="mb-4">
        <h5 className="mb-2" style={{ fontWeight: 500 }}>
          <IconContainer>
            <MenuBookIcon />
          </IconContainer>
          Tarifas y planes
        </h5>
        {item.datosPlan && (
          <Row className="mb-2">
            <Col className="col-4" style={{ fontWeight: 500 }}>
              {item.datosPlan.plan.nombre + ":"}
            </Col>
            <Col></Col>
            <Col className="text-right">
              <CurrencyFormat
                className="w-100"
                name="valorFinalPlanGuarderia"
                value={item.datosPlan.precioFinal}
                thousandSeparator={","}
                onChange={onPrecioFinalPlanInputChange}
                prefix={"$"}
                decimalSeparator={"."}
              />
            </Col>
          </Row>
        )}
        {item.datosDiasIndividuales && (
          <Row className="mb-2">
            <Col className="col-4" style={{ fontWeight: 500 }}>
              Días individuales:
            </Col>
            <Col className="text-left">
              {item.datosDiasIndividuales.diasIndividuales + " días x"}
            </Col>
            <Col className="text-right">
              <CurrencyFormat
                className="w-100"
                name="precioTotal"
                value={item.datosDiasIndividuales.precioFinal}
                thousandSeparator={","}
                onChange={onPrecioFinalDiaIndividualInputChange}
                prefix={"$"}
                decimalSeparator={"."}
              />
            </Col>
          </Row>
        )}
        {item.datosTransporte?.datosIda && (
          <Row className="mb-2">
            <Col className="col-4" style={{ fontWeight: 500 }}>
              Transporte ida:
            </Col>
            <Col className="text-left">
              {item.datosTransporte.fechas.length + " viajes x"}
            </Col>
            <Col className="text-right">
              <CurrencyFormat
                className="w-100"
                name="valorFinalIda"
                value={item.datosTransporte.datosIda.precioFinal}
                thousandSeparator={","}
                onChange={onPrecioFinalTransporteIdaInputChange}
                prefix={"$"}
                decimalSeparator={"."}
              />
            </Col>
          </Row>
        )}
        {item.datosTransporte?.datosVuelta && (
          <Row className="mb-2">
            <Col className="col-4" style={{ fontWeight: 500 }}>
              Transporte vuelta:
            </Col>
            <Col className="text-left">
              {item.datosTransporte.fechas.length + " viajes x"}
            </Col>
            <Col className="text-right">
              <CurrencyFormat
                className="w-100"
                name="valorFinalVuelta"
                value={item.datosTransporte.datosVuelta.precioFinal}
                thousandSeparator={","}
                onChange={onPrecioFinalTransporteVueltaInputChange}
                prefix={"$"}
                decimalSeparator={"."}
              />
            </Col>
          </Row>
        )}
        {item.datosTransporte?.datosIdaVuelta && (
          <Row className="mb-2">
            <Col className="col-4" style={{ fontWeight: 500 }}>
              Transporte ida y vuelta:
            </Col>
            <Col className="text-left">
              {item.datosTransporte.fechas.length + " viajes x"}
            </Col>
            <Col className="text-right">
              <CurrencyFormat
                className="w-100"
                name="valorFinalIdaVuelta"
                value={item.datosTransporte.datosIdaVuelta.precioFinal}
                thousandSeparator={","}
                onChange={onPrecioFinalTransporteIdaVueltaInputChange}
                prefix={"$"}
                decimalSeparator={"."}
              />
            </Col>
          </Row>
        )}
      </section>
    </>
  );
};
